import React, { useState } from 'react';

import { Textarea, CharacterCount } from 'components/cosmos';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import './OtherInput.scss';

const maxLength = 60;

const OthersInput = ({ show, onChange, t }) => {
  const [value, setValue] = useState('');
  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <>
      {show && (
        <>
          <Textarea
            name="other-input"
            placeholder={t(
              'users_manager.deep_search.access.modal_reason_block.placeholder'
            )}
            maxLength={maxLength}
            onChange={handleChange}
            value={value}
          />
          <CharacterCount text={value} max={maxLength} />
        </>
      )}
    </>
  );
};

OthersInput.propTypes = {
  show: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

OthersInput.defaultProps = {
  show: false
};

export default translate()(OthersInput);
